import { render, staticRenderFns } from "./classDetailHB.vue?vue&type=template&id=5be60068&scoped=true"
import script from "./classDetailHB.vue?vue&type=script&lang=js"
export * from "./classDetailHB.vue?vue&type=script&lang=js"
import style0 from "./classDetailHB.vue?vue&type=style&index=0&id=5be60068&prod&lang=less&scoped=true"
import style1 from "./classDetailHB.vue?vue&type=style&index=1&id=5be60068&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be60068",
  null
  
)

export default component.exports